import { HttpClient } from '@angular/common/http';
import { Inject, Injectable, inject } from '@angular/core';

import { Observable } from 'rxjs';

import { ActionCommentRequestBody, ActionResponseBody, EntityType } from '@lib/core/models/action.interface';
import { PagedResponse } from '@lib/core/models/paged-response';
import { SearchRequest, searchRequestToUri } from '@lib/core/models/search-request';
import { PROTECTED_API_URL } from '@lib/core/tokens/api.tokens';

import { MemberProfile, MemberProfileSearch } from '../models/member.interface';
import { MEMBERS_API_URL } from '../tokens/api.tokens';

@Injectable({
  providedIn: 'root',
})
export class MemberProfilesService {
  private http: HttpClient = inject(HttpClient);
  private readonly apiUrl: string;
  private readonly protectedApiUrl: string = inject(PROTECTED_API_URL);

  constructor(@Inject(MEMBERS_API_URL) apiUrl: string) {
    this.apiUrl = apiUrl;
  }

  searchProfiles(search: SearchRequest<MemberProfileSearch>) {
    const searchString = searchRequestToUri(search);

    return this.http.get<PagedResponse<MemberProfile>>(`${this.apiUrl}/members?${searchString}`);
  }

  getClientProfile(id: string) {
    return this.http.get<MemberProfile>(`${this.apiUrl}/members/${id}`);
  }

  getClientProfileByUserId(userId: string): Observable<MemberProfile> {
    return this.http.get<MemberProfile>(`${this.apiUrl}/members/by-user/${userId}`);
  }

  getClientProfileComments(entityId: string): Observable<PagedResponse<ActionResponseBody>> {
    const requestBody = {
      pageSize: 100,
      sortBy: 'CreatedAt',
      sortDirection: 'desc',
      entityId,
      entityType: EntityType.Member,
    };

    return this.http.post<PagedResponse<ActionResponseBody>>(`${this.protectedApiUrl}/notes/search`, requestBody);
  }

  createClientProfileComment(action: ActionCommentRequestBody): Observable<ActionResponseBody> {
    return this.http.post<ActionResponseBody>(`${this.protectedApiUrl}/notes`, action);
  }

  updateClientProfileComment(actionId: string, actionContent: string): Observable<ActionResponseBody> {
    return this.http.patch<ActionResponseBody>(`${this.protectedApiUrl}/notes/${actionId}`, { content: actionContent });
  }

  deleteClientProfileComment(actionId: string): Observable<void> {
    return this.http.delete<void>(`${this.protectedApiUrl}/notes/${actionId}/archive`);
  }
}
